import type { Order } from "./types";

/** Display-only fallback: preserves customer text and never writes/backfills an order ID. */
export function orderDisplayTitle(order: Pick<Order, "id" | "orderNumber" | "customerName" | "productName" | "orderDate" | "workTitle">): string {
  if (order.workTitle?.trim()) return order.workTitle;
  return [order.customerName.trim() || "주문자 미기록", order.orderDate || "일자 미기록",
    order.productName.trim() || "상품 미기록", order.orderNumber.trim() || order.id].join(" / ");
}
